import React, { useState, useEffect } from 'react'

import Checkbox from '@mui/material/Checkbox'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import './ChecklistPanel.scss'

const CheckboxItems = ({
  setState,
  items,
  onClick,
  checklistItemTitlePrompt,
}) => {
  const [itemsSelected, setItemsSelected] = useState(items)

  const handleClick = (checked, item, type, checklistItemTitlePrompt) => {
    const updatedItems = itemsSelected.map(i => {
      if (i.name === item.name) {
        return {
          ...i,
          checked,
        }
      }
      return i
    })
    setItemsSelected(updatedItems)
    setState(prev => ({
      ...prev,
      [checklistItemTitlePrompt]: updatedItems,
    }))
    onClick(checked, item, type, checklistItemTitlePrompt)
  }

  return (
    <>
      {items.map((item, index) => {
        return (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                checked={item.checked}
                onChange={e =>
                  handleClick(
                    e.target.checked,
                    item,
                    'CHECKBOX',
                    checklistItemTitlePrompt,
                  )
                }
                name={item.name}
              />
            }
            label={item.label}
          />
        )
      })}
    </>
  )
}

const RadioItems = ({ setState, items, onClick, checklistItemTitlePrompt }) => {
  const [selectedValue, setSelectedValue] = useState(items[0]?.id || '')

  useEffect(() => {
    setState(prev => ({
      ...prev,
      [checklistItemTitlePrompt]: selectedValue,
    }))
  }, [selectedValue, items, checklistItemTitlePrompt, setState])

  const handleChange = event => {
    setSelectedValue(event.target.name)
    const selectedItem = items.find(item => item.id === event.target.name)
    console.log('selectedItem', selectedItem)
    onClick(true, selectedItem, 'RADIO', checklistItemTitlePrompt)
  }

  return (
    <FormControl component="fieldset">
      <RadioGroup value={selectedValue} onChange={handleChange}>
        {items.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item.id}
            control={<Radio name={item.id} />}
            label={item.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

/**
 * @param {String} imageType SQUARE / HORIZONTAL / VERTICAL.
 */
const ChecklistPanel = React.forwardRef(
  (
    {
      id,
      title = null,
      titlePrompt = null,
      detail = null,
      imageUrl = null,
      items = [],
      imageType = 'SQUARE',
      onClick = () => {},
      isChecked = () => {},
      mode = 'ZERO_OR_MORE',
      setState = () => {},
    },
    ref,
  ) => {
    const availableDimensions = {
      SQUARE: { width: '160', height: '160' },
      VERTICAL: { width: '200', height: '270' },
      HORIZONTAL: { width: '300', height: '160' },
    }

    let placeholderDimensions = null
    if (imageType) {
      placeholderDimensions = availableDimensions[imageType]
    }

    return (
      <div className={`grocery-list-panel item`} ref={ref}>
        {imageUrl && placeholderDimensions && (
          <div className={`col image image-${imageType}`}>
            <img
              src={imageUrl}
              alt={imageType}
              style={{ width: '100%', height: '180px' }}
            />
          </div>
        )}
        <div className={`columns`}>
          <div className={`col content`}>
            {title && (
              <h3
                className="title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {detail && (
              <div
                className="detail"
                dangerouslySetInnerHTML={{ __html: detail }}
              />
            )}

            {items && (
              <FormGroup className={`items`}>
                {mode === 'ZERO_OR_MORE' ? (
                  <CheckboxItems
                    setState={setState}
                    items={items}
                    onClick={onClick}
                    checklistItemTitlePrompt={titlePrompt}
                  />
                ) : (
                  <RadioItems
                    setState={setState}
                    items={items}
                    onClick={onClick}
                    checklistItemTitlePrompt={titlePrompt}
                  />
                )}
              </FormGroup>
            )}
          </div>
        </div>
      </div>
    )
  },
)

export default ChecklistPanel
